'use client';
import React, { createContext, useContext, useMemo } from 'react';

import { useCurrentMediaType } from './hooks';
import { MediaType } from '@/helpers/enums';
import { useServer } from '@/modules/server/context/ServerEnvContext';

export interface IResponsiveContext {
  currentMediaType: MediaType;
}

const ResponsiveContext = createContext<IResponsiveContext | null>(null);

export function ResponsiveProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const currentMediaType = useCurrentMediaType();
  const { isMobileDevice } = useServer();

  const defaultMediaType = isMobileDevice
    ? MediaType.MOBILE_S
    : MediaType.DESKTOP;

  const contextValue = useMemo(
    () => ({ currentMediaType: currentMediaType ?? defaultMediaType }),
    [currentMediaType, defaultMediaType]
  );

  return (
    <ResponsiveContext.Provider value={contextValue}>
      {children}
    </ResponsiveContext.Provider>
  );
}

export function useResponsive() {
  const resposiveContext = useContext(ResponsiveContext);

  if (!resposiveContext) {
    throw new Error('useResponsive must be used within a ResponsiveProvider');
  }

  return resposiveContext;
}
